export default "__VITE_ASSET__DH$mJADU__"